export default {"src":"/_next/static/media/moto-side-fill.9912bfed.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};